import { Navigate } from 'react-router-dom';

/**
 * Bidding has been retired in favour of the "Make an offer" flow.
 * Buyers now propose private offers from each product page; sellers
 * accept, decline or counter from /dashboard/offers.
 *
 * This file is a graceful redirect shim - leaves the URL accessible
 * for any legacy bookmarks or inbound links.
 */
export default function Bidding() {
  return <Navigate to="/c/all" replace />;
}
